'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_tslib-15827112.js');

var BaseController = /** @class */ (function () {
    function BaseController(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
    }
    BaseController.prototype.MakeRequest = function (config, headers) {
        if (headers === void 0) { headers = {}; }
        return _tslib.__awaiter(this, void 0, void 0, function () {
            var response;
            return _tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config.headers = _tslib.__assign(_tslib.__assign({}, this.getHeaders(headers)), config.headers);
                        return [4 /*yield*/, this.httpClient.request(config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    BaseController.prototype.getUserId = function () {
        return this.config.getCookie("EndUserId");
    };
    BaseController.prototype.getHeaders = function (headers) {
        var token = this.config.getCookie("AccessToken");
        if (!token) {
            return headers;
        }
        return _tslib.__assign(_tslib.__assign({}, headers), { Authorization: "Bearer " + token });
    };
    return BaseController;
}());

exports.default = BaseController;
//# sourceMappingURL=BaseController.js.map
